import Sidebar from '../../components/Common/Sidebar';
import { ReportsDownloadList } from '../../components/_pages/ReportsDownload';

const ReportsDownload = () => {
  return (
    <>
      <Sidebar />
      <ReportsDownloadList />
    </>
  );
};

export default ReportsDownload;
